import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './pages/home';
import TextSummarizer from './pages/TextSummarizerPage';
import DocumentQA from './pages/DocQAPage';
import Footer from './components/Footer';


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/summarizer" element={<TextSummarizer />} />
          <Route path="/document-qa" element={<DocumentQA />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
